import React from "react"
import { Messages } from "@sogei/react-web-components-catalog"
function InfoTotali() {
    return (
        <React.Fragment>
            <Messages
                successMessages={[]}
                infoMessages={[]}
                warningMessages={[
                    {
                        text: "*Sono escluse le posizioni ISA per le quali non è stato dichiarato il comune"
                    }
                ]}
                dangerMessages={[]}
            ></Messages>
        </React.Fragment>
    )
}
export default InfoTotali
